import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { Row, Col, FormInstance, Form, Card, Select } from 'antd';
import { InvoicePartFormValues } from '../InvoicePartForm.types';
import { useInvoiceFormContext } from '../../../InvoiceFormProvider';

interface Props {
  form: FormInstance<InvoicePartFormValues>;
}

const InvoicePartShareForm: React.FC<Props> = ({ form }) => {
  const { disabledFields } = useInvoiceFormContext();

  return (
    <Form form={form} preserve={false} disabled={disabledFields}>
      <Card type="inner" title="Informações de partilha">
        <Row gutter={[24, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FloatingFormItem
              name={['itemTaxes', 'share', 'icmsBaseCalculationShare']}
              label="Base de Cálculo ICMS"
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6}>
            <FloatingFormItem
              name={['itemTaxes', 'share', 'fcpBaseCalculationShare']}
              label="Base de Cálculo FCP"
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6}>
            <FloatingFormItem
              name={['itemTaxes', 'share', 'icmsFcpPercentageShare']}
              label="Percentual ICMS FCP"
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6}>
            <FloatingFormItem
              name={['itemTaxes', 'share', 'internalAliquotShare']}
              label="Alíquota Interna"
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6}>
            <FloatingFormItem
              name={['itemTaxes', 'share', 'interstateAliquotShare']}
              label="Alíquota Interestadual"
            >
              <Select
                allowClear
                options={[
                  { value: 4, label: '4% - Produtos importados' },
                  {
                    value: 7,
                    label:
                      '7% - Origem: Sul e Sudeste (Exceto ES); Destino: Norte, Nordeste, Centro-Oeste e ES ',
                  },
                  { value: 12, label: '12% - Para demais casos' },
                ]}
              />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6}>
            <FloatingFormItem
              name={['itemTaxes', 'share', 'fcpRelativeIcmsShare']}
              label="ICMS relativo FCP"
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6}>
            <FloatingFormItem
              name={['itemTaxes', 'share', 'interstateIcmsShare']}
              label="ICMS Interestadual"
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>
    </Form>
  );
};

export default InvoicePartShareForm;
